import { css } from "@linaria/core";
import { easings } from "../../css-tokens/easings";

/* Calculate height of the chevron, using the Pythagorean theorem */
const height = `calc(var(--pythagoreanSize) + var(--line-width) / 2)`;
const width = `calc(${height} / 2 + var(--line-width) / 2)`;

export const chevronCls = css`
  --pythagoreanSize: 14.1421px;
  --size: 10px;
  --line-width: 2px;
  --line-color: currentColor;

  position: relative;

  padding: 0;

  height: ${height};
  width: ${width};

  display: block;

  color: inherit;

  :where(&) {
    margin: 0;
  }

  &.vertical {
    height: ${width};
    width: ${height};
  }
`;

export const horitzontalLineCls = css`
  position: absolute;
  top: 50%;
  right: 0;

  height: calc(var(--line-width) * 2);
  width: calc(var(--size) * 2);

  background-color: var(--line-color);
  border-top-left-radius: var(--line-width);
  border-bottom-left-radius: var(--line-width);
  border-top-right-radius: calc(var(--line-width) * 0.75);
  border-bottom-right-radius: calc(var(--line-width) * 0.75);

  transform-origin: calc(100% - var(--line-width)) center;
  transition: transform 150ms ${easings.inOutCubic};

  &.upper {
    transform: translateY(-50%) rotate(45deg) scale(0.5);
  }

  &.lower {
    transform: translateY(-50%) rotate(-45deg) scale(0.5);
  }

  /* translate lines -70.710% to align with the left edge of the container
   * (value based on the Pythagorean theorem) and rotate the direction of the
   * chevron by additional 90deg */
  .${chevronCls}.inversed &.upper {
    transform: translateY(-50%) scale(0.5)
      translateX(calc(var(--line-width) * 2 - 70.71%)) rotate(135deg);
  }

  .${chevronCls}.inversed &.lower {
    transform: translateY(-50%) scale(0.5)
      translateX(calc((var(--line-width) * 2 - 70.71%))) rotate(-135deg);
  }
`;

export const verticalLineCls = css`
  position: absolute;
  left: 50%;
  bottom: 0;

  height: calc(var(--size) * 2);
  width: calc(var(--line-width) * 2);

  background-color: var(--line-color);
  border-top-left-radius: var(--line-width);
  border-top-right-radius: var(--line-width);
  border-top-right-radius: calc(var(--line-width) * 0.75);
  border-bottom-right-radius: calc(var(--line-width) * 0.75);

  transform-origin: 50% calc(100% - var(--line-width));
  transition: transform 150ms ${easings.inOutCubic};

  &.upper {
    transform: translateX(-50%) rotate(45deg) scale(0.5);
  }

  &.lower {
    transform: translateX(-50%) rotate(-45deg) scale(0.5);
  }

  /* translate lines -70.710% to align with the left edge of the container
   * (value based on the Pythagorean theorem) and rotate the direction of the
   * chevron by additional 90deg */
  .${chevronCls}.inversed &.upper {
    transform: translateX(-50%) scale(0.5)
      translateY(calc(var(--line-width) * 2 - 70.71%)) rotate(135deg);
  }

  .${chevronCls}.inversed &.lower {
    transform: translateX(-50%) scale(0.5)
      translateY(calc(var(--line-width) * 2 - 70.71%)) rotate(-135deg);
  }
`;
